import { useDispatch, useSelector } from 'react-redux';
import { closeAllModals, getModalParams, openModal as openModalAction } from '..';
export const useModal = () => {
    const dispatch = useDispatch();
    const modalParams = useSelector(getModalParams);
    function openModal(modalPayload) {
        return () => dispatch(openModalAction(modalPayload));
    }
    function dispatchOpenModal(modalPayload) {
        return dispatch(openModalAction(modalPayload));
    }
    const closeModal = () => dispatch(closeAllModals());
    return { openModal, closeModal, modalParams, dispatchOpenModal };
};
//# sourceMappingURL=useModal.js.map